// extracted by mini-css-extract-plugin
export default {"div":"StockCharts_div__Zosgc","divChart":"StockCharts_divChart__fqaFa","divInCollum":"StockCharts_divInCollum__OLIk1"};